export function normalizeTokenResponseScope(
  body: Record<string, unknown>
): Record<string, unknown> {
  return Array.isArray(body.scope)
    ? { ...body, scope: body.scope.join(" ") }
    : body;
}
